import packageJson from '../../../../package.json';

type PackageJson = {
  version?: string;
};

const { version } = packageJson as PackageJson;
export const ASSET_VERSION = version ?? 'dev';

/**
 * Appends the current asset version as a query parameter to force cache invalidation.
 */
export const withAssetVersion = (path: string): string => {
  if (!ASSET_VERSION) {
    return path;
  }

  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}v=${ASSET_VERSION}`;
};
